// extracted by mini-css-extract-plugin
export default {"root":"root___d4f8I"};